<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'LANGUAGES' }]"
></breadcrumbs>

<page-header title="LANGUAGES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['../', 'crud']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_LANGUAGE"
        >{{ 'CREATE_LANGUAGE' | translate }}</a
      >
    </div>
  </ng-template>
  <ng-template let-row="row" #availableColumn>
    <span
      [translationEditableDirective]="row.get('available') ? 'YES' : 'NO'"
      >{{ (row.get('available') ? 'YES' : 'NO') | translate }}</span
    >
  </ng-template>
  <ng-template let-row="row" #isDefaultColumn>
    <span
      [translationEditableDirective]="row.get('isDefault') ? 'YES' : 'NO'"
      >{{ (row.get('isDefault') ? 'YES' : 'NO') | translate }}</span
    >
  </ng-template>
  <ng-template #addonRight>
    <form>
      <input
        class="input is-small"
        type="text"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
        [translationEditableModalDirective]="['SEARCH']"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
      />
    </form>
  </ng-template>
  <ng-template let-row="row" #actionsColumn>
    <div class="buttons">
      <a
        [routerLink]="['../crud']"
        [queryParams]="{
          available: row.get('available'),
          isDefault: row.get('isDefault'),
          name: row.get('name'),
          iso2code: row.get('iso2code')
        }"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <alert
        #deleteAlert
        (confirm)="deleteLanguageRow(row.get('iso2code'))"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
      />
      <button
        *ngIf="row.get('iso2code') !== 'en'"
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
